// https://vuex.vuejs.org/en/mutations.html
import {
  SET_LOGGEDUSER,
  SET_TOKEN,
} from "./mutations.type";
import Cookies from 'js-cookie'
import enviroment from '../enviroment';
import * as Sentry from '@sentry/browser';

const SNACKBAR_TYPE_MAP = {
  success: { color: "success", icon: "mdi-check-circle" },
  error:   { color: "error",   icon: "mdi-alert-circle" },
  warning: { color: "warning", icon: "mdi-alert" },
  info:    { color: "info",    icon: "mdi-information" },
};

export default {
  [SET_LOGGEDUSER](state, user) {
    Cookies.set('STRATEGY_USER', user, {
      domain: enviroment.cookiesDomain,
      path: '/'
  })
    state.loggedUser = user;

    if (user) {
      Sentry.setUser({
        id: user.id,
        email: user.email,
        username: user.name,
      });
    }
  },

  [SET_TOKEN](state, token) {
    state.token = token
    
    Cookies.set('STRATEGY_TOKEN', token, {
      domain: enviroment.cookiesDomain,
      path: '/'
  })
    axios.httpApi.defaults.headers.common['Authentication-Token'] = token
},
  setFCMToken(state, payload) {
    state.FCMToken = payload;
  },
  showSnackbar(state, payload) {
    if (state.snackbar.show) state.snackbar.show = false;

    setTimeout(() => {
      if (typeof payload === "string") {
        state.snackbar.message   = payload;
        state.snackbar.href      = null;
        state.snackbar.timeout   = null;
        state.snackbar.important = false;
        state.snackbar.color     = "";
        state.snackbar.icon      = null;
        state.snackbar.closable  = true;
        state.snackbar.type      = null;
        state.snackbar.show      = true;
      } else {
        const type = payload && payload.type && SNACKBAR_TYPE_MAP[payload.type] ? payload.type : null;
        const defaults = type ? SNACKBAR_TYPE_MAP[type] : {};

        state.snackbar.message   = payload.message;
        state.snackbar.href      = payload.href || null;
        state.snackbar.timeout   = payload.timeout  || null;
        state.snackbar.important = payload.important || false;
        state.snackbar.color     = payload.color    || defaults.color || "";
        state.snackbar.icon      = payload.icon     || defaults.icon  || null;
        state.snackbar.closable  = payload.closable !== undefined ? payload.closable : true;
        state.snackbar.type      = type;
        state.snackbar.show      = true;
      }
    }, 500);
  },
  loading(state, isLoading) {
    if (isLoading) {
      state.refCount += 10;
      state.isLoading = true;
    } else if (state.refCount > 0) {
      state.refCount -= 10;
      state.isLoading = state.refCount > 0;
    }
  },
  setTabs: (state, tabs) => {
    state.tabs = tabs;
  },
  setDashboardFilters: (state, filters) => {
    state.dashboardFilters = filters;
  },
  setStrategiesFilters: (state, filters) => {
    state.strategiesFilters = filters;
  },
  setStrategiesProductionFilters: (state, filters) => {
    state.strategiesProductionFilters = filters;
  },
  setManualStrategy: (state, filters) => {
    state.manualStrategy = filters;
  },
  setStrategiesPlanningFilters: (state, filters) => {
    state.strategiesPlanningFilters = filters;
  },
  setStrategiesArchivedFilters: (state, filters) => {
    state.strategiesArchivedFilters = filters;
  },
  setApproachesFilters: (state, filters) => {
    state.approachesFilters = filters;
  },
  setFiringHistoryFilters: (state, filters) => {
    state.firingHistoryFilters = filters;
  },
  setFiringFilters: (state, filters) => {
    state.firingFilters = filters;
  },
  setPreparesDailyFilters: (state, filters) => {
    state.preparesDailyFilters = filters;
  },
  setStimulusHistoryFilters: (state, filters) => {
    state.stimulusHistoryFilters = filters;
  },
  setClientsBaseFilters: (state, filters) => {
    state.clientsBaseFilters = filters;
  },
  setReportsFilters: (state, filters) => {
    state.reportsFilters = filters;
  },
  setForecastsFilters: (state, filters) => {
    state.forecastsFilters  = filters;
  },
  setEventsFilters: (state, filters) => {
    state.eventsFilters = filters;
  },
  setPotentialsFilters: (state, filters) => {
    state.potentialsFilters = filters;
  },
  setDebtTreeFilters: (state, filters) => {
    state.debtTreeFilters = filters;
  },
  setDebtTreeStimulus: (state, filters) => {
    state.debtTreeStimulus = filters;
  },
  setApproachesFlowFilters: (state, filters) => {
    state.approachesFlowFilters = filters;
  },
};
